import CloseIcon from "@mui/icons-material/Close";
import { Theme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useMemo } from "react";

type EntaDrawerProps = {
  titulo: string;
  subtitulo?: string;
  footer?: React.ReactElement;
  closeButtonProps: IconButtonProps;
  children?: React.ReactElement;
  width: string;
  minWidth: number;
  disableBackdropClick?: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    flexGrow: 1,
  },
  subtitle: {
    color: theme.palette.grey["500"],
    fontSize: 12,
  },
  paperDrawer: (props: { width: string; minWidth: number }) => ({
    width: props.width,
    minWidth: props.minWidth,
  }),
  root: {
    height: "100%",
  },
  drawerContent: {
    height: "100%",
    backgroundColor: "inherit",
  },
  content: {
    height: "100%",
    overflow: "auto",
  },
  footer: {
    paddingBottom: theme.spacing(1),
  },
}));

const EntaDrawer: React.FC<EntaDrawerProps> = (props): React.ReactElement => {
  const {
    titulo,
    subtitulo,
    children,
    footer,
    closeButtonProps = {},
    width,
    minWidth,
  } = props;

  const classes = useStyles({ width, minWidth });
  const finalCloseProps: IconButtonProps = useMemo(
    () => ({
      ...closeButtonProps,
      edge: "end",
      color: "inherit",
      "aria-label": "menu",
    }),
    [closeButtonProps]
  );

  const handleClose = (event: any) => {
    finalCloseProps.onClick?.(event);
  };

  return (
    <Drawer
      anchor="right"
      open={true}
      classes={{ paper: classes.paperDrawer }}
      disableEnforceFocus
      onClose={handleClose}
    >
      <Grid container direction="column" className={classes.root}>
        <Grid item>
          <AppBar position="static" color="inherit" elevation={0}>
            <Toolbar>
              <Typography variant="h6" className={classes.title}>
                {titulo}
                {subtitulo && (
                  <Typography variant="subtitle1" className={classes.subtitle}>
                    {subtitulo}
                  </Typography>
                )}
              </Typography>

              <IconButton
                {...finalCloseProps}
                onClick={handleClose}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs className={classes.content}>
          {children && (
            <Container className={classes.drawerContent}>{children}</Container>
          )}
        </Grid>
        {footer && <Container className={classes.footer}>{footer}</Container>}
      </Grid>
    </Drawer>
  );
};

export default EntaDrawer;
